<template>
    <section>
        <b-field label="Daten aus Account" horizontal  class="draggable-fix">
            <p class="control">
                <div class="columns draggable-fields" v-if="typeof $root.event.fields !== 'undefined'">
                    <div class="column" v-if="typeof $root.event.fields.editable !== 'undefined'">
                        <div class="box">
                            <header>
                                Bearbeitbare Felder
                            </header>
                            <Draggable class="list-group" :list="$root.event.fields.editable" group="lists">
                                <a class="button is-info draggy" v-for="(element, index) in $root.event.fields.editable"
                                   :key="element.name">
                                    {{ element.name }} ({{ element.id }})
                                </a>
                            </Draggable>
                        </div>
                    </div>
                    <div class="column" v-if="typeof $root.event.fields.shown !== 'undefined'">
                        <div class="box">
                            <header>
                                Angezeigte Felder
                            </header>
                            <Draggable class="list-group" :list="$root.event.fields.shown" group="lists">
                                <a class="button is-warning draggy" v-for="(element, index) in $root.event.fields.shown"
                                   :key="element.name">
                                    {{ element.name }} ({{ element.id }})
                                </a>
                            </Draggable>
                        </div>
                    </div>
                    <div class="column" v-if="typeof $root.event.fields.available !== 'undefined'">
                        <div class="box">
                            <header>
                                Verfügbare Felder
                            </header>
                            <Draggable class="list-group" :list="$root.event.fields.available" group="lists">
                                <a class="button is-success draggy" v-for="(element, index) in $root.event.fields.available"
                                   :key="element.name">
                                    {{ element.name }} ({{ element.id }})
                                </a>
                            </Draggable>
                        </div>
                    </div>
                </div>
            </p>
        </b-field>
        <p v-if="typeof $root.event.guests !== 'undefined'">
            <hr>
            <b-field label="Zusätzliche Daten" horizontal>
                <b-taginput v-model="$root.event.guests.guestFields" :before-adding="(r) => addAdditionalField(r)"
                            field="label" ellipsis icon="user-tag" placeholder="Feld hinzufügen">
                </b-taginput>
                <p class="control">
                    <a @click="isGuestsCardModalActive = true" class="button is-primary is-outlined">
                        <b-icon size="is-small" icon="cogs" pack="fad"></b-icon>
                    </a>
                </p>
            </b-field>
            <hr>
            <b-field label="Anzahl Begleitungen" horizontal>
                <b-numberinput controls-position="compact" icon-pack="fal" min="0" v-model="$root.event.guests.companies">
                </b-numberinput>
            </b-field>
            <b-field label="Daten von Begleitung" horizontal v-if="$root.event.guests.companies > 0">
                <b-taginput v-model="$root.event.guests.companiesFields" :before-adding="(r) => addCompanyField(r)"
                            field="label" ellipsis icon="user-tag" placeholder="Feld hinzufügen">
                </b-taginput>
                <p class="control">
                <a @click="isCompaniesCardModalActive = true" class="button is-primary is-outlined">
                    <b-icon size="is-small" icon="cogs" pack="fad"></b-icon>
                </a>
            </p>
            </b-field>
        </p>

        <b-modal :active.sync="isCompaniesCardModalActive" scroll="keep" @close="saveEvent()">
            <div class="card is-modal">
                <header class="card-header">
                    <p class="card-header-title">
                        Daten von Begleitung (Format / Pflichtfeld)
                    </p>
                </header>
                <div class="card-content">
                    <div class="content">
                        <Draggable :list="$root.event.guests.companiesFields" group="companiesFields" :options="{handle:'label.label'}">
                            <b-field :label="field.label" horizontal v-for="field in $root.event.guests.companiesFields" class="draggyLabel field-switch-fix">
                                <b-switch v-model="field.required">
                                    Pflichtfeld
                                </b-switch>
                                <b-select placeholder="Wählen Sie ein Format" v-model="field.type">
                                    <option
                                            v-for="option in inputTypes"
                                            :value="option.type"
                                            :key="option.type">
                                        {{ option.name }}
                                    </option>
                                </b-select>
                                <b-input v-if="field.type == 'enum'" v-model="field.options" placeholder="Mehrere Möglichkeiten durch Komma getrennt"></b-input>
                            </b-field>
                        </Draggable>
                        <hr>
                        <b-button type="is-success" @click="saveEvent()">Speichern</b-button>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal :active.sync="isGuestsCardModalActive" scroll="keep" @close="saveEvent()">
            <div class="card is-modal">
                <header class="card-header">
                    <p class="card-header-title">
                        Zusätzliche Daten (Format / Pflichtfeld)
                    </p>
                </header>
                <div class="card-content">
                    <div class="content">
                        <Draggable :list="$root.event.guests.guestFields" group="guestFields" :options="{handle:'label.label'}">
                            <b-field :label="field.label" horizontal v-for="field in $root.event.guests.guestFields" class="draggyLabel field-switch-fix">
                                <b-switch v-model="field.required">
                                    Pflichtfeld
                                </b-switch>
                                <b-input v-if="field.type == 'enum'" v-model="field.options" placeholder="Mehrere Möglichkeiten durch Komma getrennt" expanded></b-input>
                                <b-select placeholder="Wählen Sie ein Format" v-model="field.type">
                                    <option
                                            v-for="option in inputTypes"
                                            :value="option.type"
                                            :key="option.type">
                                        {{ option.name }}
                                    </option>
                                </b-select>
                            </b-field>
                        </Draggable>
                        <hr>
                        <b-button type="is-success" @click="saveEvent()">Speichern</b-button>
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    export default {
        name: 'Guests',
        components: {},
        props: {},
        data() {
            return {
                isCompaniesCardModalActive: false,
                isGuestsCardModalActive: false,
                inputTypes: [
                    {
                        name: 'einfacher Text',
                        type: 'misc'
                    },
                    {
                        name: 'mehrzeiliger Text',
                        type: 'multiline'
                    },
                    {
                        name: 'eMail',
                        type: 'email'
                    },
                    {
                        name: 'Datum',
                        type: 'date'
                    },
                    {
                        name: 'Uhrzeit',
                        type: 'time'
                    },
                    {
                        name: 'Ganzzahl',
                        type: 'int'
                    },
                    {
                        name: 'Auswahl',
                        type: 'enum'
                    }
                ]
            }
        },
        methods: {
            update(id = this.$route.params.id) {
                return true
            },
            saveEvent() {
                this.isCompaniesCardModalActive = false
                this.isGuestsCardModalActive = false
                this.$root.saveEvent(this.$route.params.id)
            },
            camelize(str) {
                return str.replace(/\W+(.)/g, (match, chr) => chr.toUpperCase())
            },
            addCompanyField(value) {

                let name = this.camelize(value)
                if (typeof this.$root.event.guests.companiesFields === 'undefined') {
                    this.$root.event.guests.companiesFields = []
                }
                if (this.$root.event.guests.companiesFields.filter(r => r.name == name).length > 0) {
                    this.$buefy.toast.open({
                        message: 'Bereits vorhanden!',
                        type: 'is-danger'
                    })
                } else {
                    this.$root.event.guests.companiesFields.push({
                        label: value,
                        name: name
                    })
                    this.saveEvent()
                    this.$buefy.toast.open({
                        message: 'Feld eingefügt.',
                        type: 'is-success'
                    })
                }

            },
            addAdditionalField(value) {

                let name = this.camelize(value)
                if (typeof this.$root.event.guests.guestFields === 'undefined') {
                    this.$root.event.guests.guestFields = []
                }
                if (this.$root.event.guests.guestFields.filter(r => r.name == name).length > 0) {
                    this.$buefy.toast.open({
                        message: 'Bereits vorhanden!',
                        type: 'is-danger'
                    })
                } else {

                    this.$root.event.guests.guestFields.push({
                        label: value,
                        name: name,
                        type: 'misc'
                    })
                    this.saveEvent()
                    this.$buefy.toast.open({
                        message: 'Feld eingefügt.',
                        type: 'is-success'
                    })
                }
                return false
            }
        },
        created() {
            // fetch the data when the view is created and the data is
            // already being observed

            if (typeof this.$root.event.guests !== 'object') {
                this.$root.event.guests = {}
            }
            if (!this.$root.event.guests.companiesFields) {
                this.$root.event.guests.companiesFields = []
            }
            if (!this.$root.event.guests.guestFields) {
                this.$root.event.guests.guestFields = []
            }
            this.$root.event.fields.available = []
            this.$root.env.account.fields.filtered.forEach(f => {
                if(this.$root.event.fields.editable.filter(e => e.id == f.id).length > 0) return
                if(this.$root.event.fields.shown.filter(e => e.id == f.id).length > 0) return
                this.$root.event.fields.available.push(f)
            })
            this.update()

        },
        computed: {}

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
    .c-preview {
        width: 50px;
    }

    .draggable-fields {
        max-width: 700px;
    }

    .draggable-fields header {
        font-weight: bold;
    }

    .list-group .button {
        margin-bottom: 5px;
        display: block;
    }
</style>
